
import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown, Search, Star, Sparkles, TrendingUp } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const ExploreMenu = () => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="flex items-center text-gray-600 hover:text-gray-900">
          Explore
          <ChevronDown className="ml-1 h-4 w-4" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-56">
        <DropdownMenuLabel>Discover Agents</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem>
          <Link to="/browse" className="flex items-center w-full">
            <Search className="mr-2 h-4 w-4" />
            Browse All Agents
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem>
          <Link to="/browse?tab=featured" className="flex items-center w-full">
            <Star className="mr-2 h-4 w-4" />
            Featured Agents
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem>
          <Link to="/browse?tab=new" className="flex items-center w-full">
            <Sparkles className="mr-2 h-4 w-4" />
            New Releases
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem>
          <Link to="/browse?tab=popular" className="flex items-center w-full">
            <TrendingUp className="mr-2 h-4 w-4" />
            Popular
          </Link>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ExploreMenu;
